import { MdOutlineAddCircle } from 'react-icons/md';
import {
  Column,
  PaletteInput,
  Row,
  SecondaryButton,
  ThinBorderStyle,
} from './DesignSystem';
import { Palette } from './Palette';
import {
  EnableTypographyPalette,
  NewTypographyID,
  TypographyPreview,
  useTypographyPreview,
} from './TypographyPreview';
import { useCode } from '@/services/CodeService';
import { useWindows } from './Windows.tsx';
import { useMemo, useEffect } from 'react';

export function TypographyPalette() {
  const { state, dispatch, dispatchHelpers } = useTypographyPreview();
  const { state: windowState, dispatch: windowDispatch } = useWindows();
  const { dispatchHelpers: codeDispatchHelpers } = useCode();

  const hasEmptyTypographyStyle = state.typographyStyles?.some(
    (e) => e.name === '',
  );
  const canAddTypographyStyle = !(hasEmptyTypographyStyle || state.isInSlate);
  const showPreviewText = !state.isInSlate;
  const contentWidth = 100;

  useEffect(
    function setWidthIfUnset() {
      windowDispatch({
        type: 'setSize',
        id: 'colors',
        size: { width: contentWidth },
      });
    },
    [windowDispatch, contentWidth],
  );

  if (!EnableTypographyPalette) {
    return <></>;
  }

  return (
    <Palette
      title="Typography"
      windowID="typography"
      trailingAction={
        state.isInSlate || (
          <SecondaryButton
            text={'View Source'}
            onClick={() => {
              codeDispatchHelpers.toggle({ source: 'typography_styles' });
            }}
          />
        )
      }
    >
      <Column>
        {showPreviewText && (
          <PaletteInput
            style={ThinBorderStyle}
            type="text"
            placeholder="Preview Text"
            value={state.previewText ?? ''}
            onChange={(text) => {
              dispatch({ type: 'previewText', text });
            }}
          />
        )}

        {state.typographyStyles?.map((typographyStyle) => {
          return (
            <div key={typographyStyle.id} style={{ marginBlockStart: 8 }}>
              <TypographyPreview typographyStyle={typographyStyle} />
            </div>
          );
        })}

        {canAddTypographyStyle && (
          <Row
            style={{
              ...ThinBorderStyle,
              marginBlockStart: 8,
              paddingBlock: 8,
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => {
              dispatchHelpers.addStyle({
                typographyStyle: {
                  id: NewTypographyID(),
                  name: '',
                  details: {
                    fontName: '',
                    fontSize: 12,
                  },
                },
              });
            }}
          >
            <MdOutlineAddCircle size={20} />
            <div style={{ marginInlineStart: 8 }}>ADD</div>
          </Row>
        )}
      </Column>
    </Palette>
  );
}
